module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_f_normal.a2a43dfe.png";